/**
 * Exitpopup widget loaded inside its own iframe
 */
// import chatExitPopupTemplate from '../templates/exit_popup/exitpopup_template.ejs';

import RDEPUIController from './RDEPUIController';
import { BaseWidget } from '../core/BaseWidget';
import WidgetTypes from '../core/enums/WidgetTypes';
import WidgetView from '../core/WidgetView';
import TempCache from '../core/enums/TempCache';
import BrandingWidget from '../core/enums/BrandingWidget';
import ChatMode from '../core/hooks/ChatMode';
// import WebSmsFormValidator from '../core/hooks/WebSmsFormValidator';
import ADACompliant from '../core/hooks/ADACompliant';
import { InviteSize } from '../core/enums/Enum';
import parseTemplate from '../core/hooks/parseTemplate';
import Branding from '../core/hooks/Branding';
import getStyle from '../core/hooks/getStyle';
import throttleByFunctionName from '../core/hooks/throttleByFunctionName';
import AgentImageHandler from '../core/hooks/AgentImageHandler';
import loadJQuery from '../core/hooks/loadJQuery';
import loadJQueryPlugins from '../core/loadJQueryPlugins';
import setEpWindowStyles from '../core/hooks/setEpWindowStyles';
import GlobalVariables from '../core/GlobalVariables';
import RunAsSoonAs from '../core/hooks/RunAsSoonAs';
import centerElement from '../core/hooks/centerElement';
import StringUtils from '../core/hooks/StringUtils';
import ChatEvents from '../core/hooks/ChatEvents';
import WidgetStates from '../core/hooks/WidgetStates';
import getCookieValue from '../core/hooks/getCookieValue';
import hideElement from '../core/hooks/hideElement';
import logIt from '../../logIt';
import ImportEPTemplateFactory from '../core/imports/ImportEPTemplateFactory';
import addTargetBlank from '../core/hooks/addTargetBlankToAnchorString';

export default class ExitChatWindow extends BaseWidget {
    constructor(options) {
        super(
            Object.assign(options, {
                widget: WidgetTypes.ExitPopup,
            })
        );
        this.adjustTextAreaHeight = function (e, me, options) {
            var targetElem = me.$(options.targetElement, me.context);
            //this resets to the min-height defined in the targetElement.
            var resetHeight = targetElem.css('minHeight');
            if (options) {
                if (options.reset || e.scrollHeight < 50) {
                    targetElem.css({ height: resetHeight });
                } else if (e.scrollHeight > 50) {
                    targetElem.css({ height: '1px' });
                    targetElem.css({ height: e.scrollHeight + 'px' });
                }
            }
        };
        this.CONTAINER_Z_INDEX = 9999999;
        this.view = null;
        if (this.isPageRefreshed()) {
            loadJQuery().then(_ => {
                loadJQueryPlugins(ApexChat.ApexChatJquery)
                this.$ = ApexChat.ApexChatJquery;
                this.ready();
            })
        } else {
            this.ready();
        }
    }

    ready() {
        super.ready();
        const me = this;
        const hideIt = function () {
            me.hide();
        };
        const maximizeIt = function (args) {
            if (me.shouldEPAppear()) {
                me.invokeChatInterceptor();
                me.maximize();
            }
        };
        const minimizeIt = function (args) {
            me.minimize();
        };
        this.subscribe(WidgetTypes.Bar + WidgetStates.Clicked, hideIt);
        this.subscribe(WidgetTypes.Tab + WidgetStates.Clicked, hideIt);
        this.subscribe(WidgetTypes.PreChat + WidgetStates.Clicked, hideIt);
        this.subscribe(WidgetTypes.ExitPopup + WidgetStates.MouseExit, maximizeIt);
        this.subscribe(WidgetTypes.ExitPopup + WidgetStates.ShownMinimized, minimizeIt);
        this.subscribe(WidgetTypes.EPUIController + ChatEvents.OnChatReInit, () => {
            if (me.uicontroller && !me.uicontroller?.reInitChatSubscribeForEP) {
                me.reInitChatEP();
            }
        });
        this.create();
    }

    reInitChatEP() {
        const me = this;
        me.uicontroller.reInitChatSubscribeForEP = true; // only once time subscribe OnChatReInit function
        if (ApexChat.options.exitpopup.exitPopupMessages.length > 0) {
            me.uicontroller.queuePredefinedQTs();
        } else {
            me.uicontroller.renderPredefinedMessages();
        }
        me.uicontroller.resetCurrentEPState();
        me.uicontroller.firstMsgSent = false;
    }

    shouldEPAppear() {
        const me = this;
        const isEPChatEnded = ApexChat.storageAPI.Get('livechat_exitpopup_is_closed');
        if (me.isChatClosed() && isEPChatEnded) {
            return false;
        }
        const currentState = me.getCurrentState();
        const domState = me.state.getStateValue(WidgetTypes.DOM);
        const winState = me.state.getStateValue(WidgetTypes.Windowed);
        const formState = me.state.getStateValue(WidgetTypes.VisitorForm);
        if (
            currentState == WidgetStates.ShownMaximized ||
            currentState == WidgetStates.ShownMinimized ||
            currentState == WidgetStates.Closed ||
            currentState == WidgetStates.Hidden
        ) {
            return false;
        }
        if (formState == WidgetStates.ShownMaximized) {
            return false;
        }
        if (
            ApexChat.options.chatMode == ChatMode.DOM &&
            domState &&
            domState !== WidgetStates.ShownNormal
        ) {
            return false;
        }
        if (
            ApexChat.options.chatMode == ChatMode.Windowed &&
            winState == WidgetStates.ShownNormal
        ) {
            return false;
        }
        return true;
    }

    create() {
        super.create();
        const me = this;
        me.show();
    }

    show() {
        const lastState = this.getCurrentState();
        const pageIsRefreshed = this.isPageRefreshed();
        const me = this;
        super.show();
        // if the chat options aren't preloaded, load them on-demand
        if (me.options.preloadEnabled) {
            me.preloadChatOptions(() => {
                me.preLoadedOptions = ApexChat.getPreloadedChatOptions();
                ApexChat.preLoadedOptions = me.preLoadedOptions;
            });
        }
        if (pageIsRefreshed) {
            if (lastState === WidgetStates.ShownMaximized) {
                me.maximize(true);
            } else if (lastState == WidgetStates.ShownMinimized) {
                me.minimize(true);
            }
        } else if (lastState === WidgetStates.ShownMaximized && !pageIsRefreshed) {
            // this happens when user opens ep on one tab and opens the same page on another tab without
            // refreshing.
            me.maximize(true);
        }
    }

    createView(chatOptions) {
        const me = this;
        /**
         * Parse and return theme css template file for EP
         * @param options
         * @returns {string|string|ApexChat.Portal.ThemePanel.getSkinData.chatStyle}
         */
        const GetEpSkinTemplate = (options) => {
            const epConig = JSON.parse(options.exitPopupChat.rdEpThemeSettings);
            const chatConfig = JSON.parse(options.rdThemeSettings);
            if (!epConig.footer) {
                // some old themes do not have footer section
                epConig.footer = { poweredByFont: '' };
            }
            let skinConfig = {
                container: '', // set empty the <#=container#> property
                rdChat: chatConfig, // we need to set some general RD Chat setting
                exitPopupChat: epConig
            };
            const brandingInfo = chatConfig.branding || {};
            if (brandingInfo.brandingIsEnabled) {
                skinConfig.global = { branding: brandingInfo };
                skinConfig = new Branding().init({
                    widget: BrandingWidget.RD_EP,
                    brandConfig: skinConfig
                }).getBrandedConfig();
            }
            return skinConfig;
        };
        const styleConfig = GetEpSkinTemplate(me.options);
        if (!chatOptions && me.renderedEPOnce) {
            return;
        }
        setEpWindowStyles(me.DOM, styleConfig);

        setEpWindowStyles(
            me.DOM, {
            ...styleConfig,
            webToText: {
                webToTextBackgroundColor: me.options.webToTextBackgroundColor,
                webToTextBackgroundGradientColor: me.options.webToTextBackgroundGradientColor,
                webToTextColorType: me.options.webToTextColorType,
            },
            isRDPlusTheme: ApexChat.IsRoundedDynamicPlusTheme,
        }
        );
        me.renderedEPOnce = true;
        me.uicontroller = null; // controller gets set on state transition: min or max because
        me.options.getFormatedDay = ApexChat.getFormatedDay("dddd, d MMMM");

        const epTemplate = ImportEPTemplateFactory(me.updateOptions(Object.assign(me.options, me.preLoadedOptions)));
        me.options.poweredBy = addTargetBlank(me.options.poweredBy || "");

        me.view = new WidgetView({
            identifier: WidgetTypes.ExitPopup,
            dom: this.DOM,
            cssLinkId: 'ExitChatWindow',
            cssLink: `${GlobalVariables.CdnBaseUrl}contents/scripts/dist/${ApexChat.Theme}/exitpopup.css?ver=${env.BUILD_HASH}`,
            templates: [
                {
                    key: WidgetStates.ShownMaximized,
                    tpl: epTemplate.exitPopupThemeTemplate(me.updateOptions(Object.assign(me.options, me.preLoadedOptions))),
                    // tpl: chatExitPopupTemplate(Object.assign(me.options, me.preLoadedOptions)),
                    model: Object.assign(me.options, me.preLoadedOptions),
                    beforeRender(tpl) {
                        tpl.model.chatMessageTemplate = epTemplate.exitPopupThemeTemplate(me.updateOptions(tpl.model)),
                            // tpl.model.chatMessageTemplate = chatExitPopupTemplate(tpl.model);
                            tpl.model.exitPopupChat.chatTitle = parseTemplate(
                                tpl.model.exitPopupChat.chatTitleTemplate,
                                tpl.model
                            );

                    },
                    afterRender(tpl) {
                        const vwMax = this;
                        Object.assign(vwMax.elements, {
                            textboxSelector: '.apex-input',
                            containerSelector: `#${WidgetTypes.ExitPopup}${WidgetStates.ShownMaximized}`,
                            // minimizeSelector: '#apexchat-ep-minimize',
                            agentTitle: '.apex-profile-usertitle', // participantsSelector
                            clickSourceId: '.apex-powerdby',
                            messagesContainerSelector: '.apex-transcript',
                            typingIndicatorSelector: '.apex-agent',
                            minimizeSelector: '.apex-ep-minimizestate',
                            maximizeState: '.apex-ep-maximizestate',
                            closeSelector: '.apex-ep-closemodel',
                            handlerImageSelector: '.Apex-agentImage',
                            minimizedImage: '.apex-img-minimized-invite',
                            companyTitle: '.apex-company-title',
                            clicktoStart: '.apex-start-chat',
                            minimizePoweredBy: '.apex-powerdby-minimized',
                            popoutSelector: '.apex-ep-openpopup',
                            clickSelector: '.apex-btn',
                            soundControl: '.apex-msg-notification',
                            soundMute: '.apex-sound-mute',
                            soundUnmute: '.apex-sound-unmute',
                            regionEditorContainer: '#apexchat_exitpopup_region_container',
                            regionEditorContainerWrapper: `#${tpl.model.exitPopupRegionEditorContainerId}`
                        });
                        // me.createRegionEditor();
                        me.$(vwMax.elements.clickSelector, me.DOM).click(() => { });
                        me.uicontroller = new RDEPUIController({
                            model: tpl.model,
                            elements: vwMax.elements,
                            context: me.DOM,
                            ADAHandler: me.handleADA.bind2(me),
                            execChatStartHandler: me.execChatStartHandler.bind2(me),
                            execChatStartHandlerWithThrottle:
                                me.execChatStartHandlerWithThrottle.bind2(me)
                        });
                        me.uicontroller.bindVolumeMuteEvents(
                            me.DOM.querySelector(me.uicontroller.options.elements.volumeMuteUnmute),
                            me.uicontroller.toggleMuteClass
                        );
                        me.uicontroller.toggleMuteClass(
                            me,
                            me.DOM.querySelector(me.uicontroller.options.elements.volumeMuteUnmute)
                        );

                        if (me.options.chatMode === ChatMode.Windowed) {
                            me.$(vwMax.elements.popoutSelector, me.DOM).click(() => {
                                me.options.chatInitiatedBy = 'ExitPopup';
                                me.state.changeState({
                                    origin: WidgetTypes.ExitPopup,
                                    toState: WidgetStates.Hidden
                                });
                                me.startWindowedChat(me.options);
                            });
                        }
                        me.uicontroller.initAgentNotFoundOverlay('.apex-col-2');
                        me.uicontroller.show(tpl.key); // _max or _min
                        if (me.options && me.options.scriptBotEnabled) {
                            // if script bot is enabled removed menu
                            me.uicontroller.bindRestartChatEvents(
                                me.DOM.querySelector(
                                    me.uicontroller.options.elements.restartVAChatSelector

                                ),
                                true
                            );
                            me.uicontroller.bindTransferChatEvents.bind2(me)(
                                me.$(me.uicontroller.options.elements.transferChatSelector, me.DOM)
                            );
                            me.uicontroller.initRestartOverlay();
                        }
                        me.options.$ = me.$;
                        me.options.context = me.DOM;
                        me.options.phoneWarningSelector = '.apexchat_error_message';
                        me.options.nameWarningSelector = '.apexchat_error_message_for_nameInput';
                        import(/* webpackChunkName: "webSmsFormValidator" */ '../core/hooks/WebSmsFormValidator').then(module => {
                            const WebSmsFormValidator = module.default
                            const smsForm = WebSmsFormValidator(me.options);
                            smsForm.init();
                            smsForm.reset();
                            smsForm.bind();
                        })

                        if (me.options.hasSmsNumber) {
                            me.$('.ep-submit-button', me.DOM).on('click', () => {
                                throttleByFunctionName(() => {
                                    me.$('.ep-submit-button', me.DOM).text('Sending...').addClass('pointer-event-none');
                                    if (!me.uicontroller.isChatroomAlive()) { // if chatroom is not alive and user click on transfer chat option
                                        me.execChatStartHandler(function () {
                                            //hack to resize the textarea - bringing focus back to textarea
                                            me.uicontroller.messageInput.focus();
                                            me.chatStarted = true;
                                            logIt('loading chat room on 1st msg...');
                                            me.uicontroller.loadChatRoom();
                                            me.handleADA(me.uicontroller.clickButton[0], me.uicontroller.sendMessage.bind2(me.uicontroller));
                                            RunAsSoonAs(function () {
                                                me.$('.submit-button', me.DOM).click();
                                                me.uicontroller.firstMsgSent = true;
                                                me.$('.ep-submit-button', me.DOM).text('Continue').removeClass('pointer-event-none');

                                            }, function () {
                                                return getCookieValue('livechat_chat_id') > 0;
                                            })
                                        });
                                        me.options.chatTransfer = true;
                                        me.uicontroller.showTyping();
                                    } else {
                                        me.$('.ep-submit-button', me.DOM).text('Continue').removeClass('pointer-event-none');
                                        me.$('.submit-button', me.DOM).click();
                                    }
                                }, 7, 'transferWebToTextEP')();
                            });

                        }
                        // ADA Compliance
                        // summary: CSS Class 'apexchat_ada_compliance' has no CSS Styling behind it means it won't effect on UI.
                        // Its only for detecting the ADA Complianced HTML elements on which we do need to have the TAB Focus.
                        // This is the Utility function which takes all HTML elements having the class 'apexchat_ada_compliance' as ARRAY, and apply the TabIndex on all of them.
                        ADACompliant.push(
                            me.$('.apexchat_ada_compliance', me.DOM)
                        ).apply();
                        // me.handleADA(me.uicontroller.closeButton[0], me.uicontroller.end.bind2(me.uicontroller));
                        me.handleADA(me.$(vwMax.elements.closeSelector, me.DOM)[0], () => {
                            me.uicontroller.end();
                        });
                        me.handleADA(me.$(vwMax.elements.minimizeSelector, me.DOM)[0], () => {
                            me.minOrMax(WidgetStates.ShownMinimized);
                        });
                        // CHAT-5210 - [Discarded] - unbinding is not needed and causing CHAT-9148
                        // me.$(vwMax.elements.clickSelector, me.DOM).unbind('click');
                        const startChatOnFirstMsg = function (simulateMessages) {
                            // restricting user from sending empty message CHAT-9556
                            // also check page is refreshed or not if not then execute
                            if (
                                StringUtils.isNull(
                                    me.$(me.uicontroller.messageInput).val().trim()
                                ) &&
                                !me.uicontroller.isPageRefreshed()
                            ) {
                                return;
                            }
                            if (!me.uicontroller.firstMsgSent) {
                                if (me.uicontroller.pokeMessageJob) {
                                    // in case of RD EP
                                    me.uicontroller.pokeMessageJob.stop(); // after first response, the pokeMessage job for predefinned is over
                                }
                                if (
                                    me.uicontroller.QTRendererExt &&
                                    me.uicontroller.QTRendererExt.isLastMessageFullText()
                                ) {
                                    if (!me.uicontroller.QTRendererExt.isLastFullTextValidated) {
                                        // just return if FT was invalid as per sendMessage
                                        return;
                                    }
                                    // me.uicontroller.disableInput();
                                }
                                if (
                                    !ApexChat.IsShowDisclaimeOverlay &&
                                    me.options.shouldShowLocationDisclaimer
                                ) {
                                    ApexChat.IsShowDisclaimeOverlay = true;
                                    me.uicontroller.showDisclaimerOverlay(
                                        me.options.locationDisclaimerText
                                    );
                                }
                                me.uicontroller.firstMsgSent = true;
                                me.uicontroller.reInitChatSubscribeForEP = false;
                                me.uicontroller.messageInputText =
                                    me.$(me.uicontroller.autoCompleteInput).is(':visible')
                                        ? me.$(me.uicontroller.autoCompleteInput).val()
                                        : me.$(me.uicontroller.messageInput).val();
                                me.uicontroller.messageInput.value = '';
                                me.uicontroller.autoCompleteInput.value = '';
                                if (simulateMessages) {
                                    me.uicontroller.simulatePlainTextPredefinedResponse({
                                        msgText: me.uicontroller.messageInputText
                                    });
                                    me.uicontroller.messageInputText = ''; // do not keep message in inputText after simulated message send
                                }
                                // CHAT-5821-Reset Height of text area input
                                // After sending message of 2-3 lines reset height of text input back to normal, on first message sent
                                // me.adjustTextAreaHeight(this, me.uicontroller, {
                                //     reset: true,
                                //     targetElement: '#apexchat_ep_textarea_input'
                                // });
                                // hack to resize the textarea
                                me.uicontroller.messageInput.blur();
                                me.execChatStartHandler(() => {
                                    // hack to resize the textarea - bringing focus back to textarea
                                    me.uicontroller.messageInput.focus();
                                    me.chatStarted = true;
                                    logIt('loading chat room on 1st msg...');
                                    me.uicontroller.loadChatRoom();
                                    me.uicontroller.sendMsgWhenChatroomAvailable();
                                    // for all subsequent msgs
                                    me.handleADA(
                                        me.uicontroller.clickButton[0],
                                        me.uicontroller.sendMessage.bind2(me.uicontroller)
                                    );
                                });
                            }
                        };
                        // the following must run once in the life of an EP
                        me.$(vwMax.elements.clickSelector, me.DOM).click((e) => {
                            startChatOnFirstMsg(true);
                        });
                        // for 1st msg
                        me.handleADA(me.uicontroller.clickButton[0], startChatOnFirstMsg.bind2(me));
                        me.$(me.uicontroller.autoCompleteInput, me.DOM).keydown, ((e) => {
                            if (e.keyCode === 13) {
                                startChatOnFirstMsg(true);
                            }
                        });
                        me.$(vwMax.elements.textboxSelector, me.DOM).keydown((e) => {
                            if (
                                e.keyCode === 13 &&
                                !me.$(me.uicontroller.autoCompleteInput, me.DOM).is(':visible')
                            ) {
                                startChatOnFirstMsg(true);
                            }
                        });

                        // ZEE: the following block is  buggy, no me.DOM specified; TODO: double check
                        me.$('#livechat_send_message_button').click(() => {
                            me.$('[data-role=footer]').show();
                            me.$('.livechat_body').addClass('reset_messages_box_height');
                        });
                        me.$(vwMax.elements.minimizeSelector, me.DOM).click(() => {
                            me.state.changeState({
                                origin: WidgetTypes.ExitPopup,
                                toState: WidgetStates.ShownMinimized
                            });
                            me.minOrMax(WidgetStates.ShownMinimized);
                        });
                        const chatId = ApexChat.storageAPI.Get(TempCache.CHAT_ID_COOKIE) || 0;
                        if (chatId) {
                            startChatOnFirstMsg();
                        }
                        me.uicontroller.renderMultiLanguageDropDown({
                            containerId: vwMax.elements.multiLanguage_dropdown_container,
                            dropdownId: vwMax.elements.multiLanguage_dropdown_select
                        });
                        me.uicontroller.toggleSMSNumberInput(
                            me.DOM.querySelectorAll(me.uicontroller.options.elements.actionMenuStartSMSChat), {
                            container: '#apexchat_rd_chat_content',
                            element: '#switchto-text-chat-in-content'
                        }
                        );
                        me.uicontroller.toggleSMSNumberInput(
                            me.DOM.querySelectorAll(me.uicontroller.options.elements.smsBottomSheetClose)
                        );
                        me.resize(tpl.key);
                        // if (me.options && me.options.exitPopupADACss) {
                        //     // apply ADA CSS when user zooming the widget.
                        //     handleZooming(
                        //         me.options.exitPopupADACss,
                        //         'apexchat_Iframe_ep_ada_css',
                        //         me.DOM
                        //     );
                        // }
                    }
                },
                {
                    key: WidgetStates.ShownMinimized,
                    tpl: me.options.exitPopupWidgetTemplateMinimized,
                    model: Object.assign(me.options, me.preLoadedOptions),
                    beforeRender(tpl) {
                        tpl.model.invitationMinimizedText = parseTemplate(
                            tpl.model.invitationMinimizedTextTemplate,
                            tpl.model
                        );
                        tpl.model.exitPopupChat.chatTitle = parseTemplate(
                            tpl.model.exitPopupChat.chatTitleTemplate,
                            tpl.model
                        );
                    },
                    afterRender(tpl) {
                        const vwMin = this;
                        Object.assign(vwMin.elements, {
                            containerSelector: `#${WidgetTypes.ExitPopup}${WidgetStates.ShownMinimized}`,
                            agentTitle: '.apex-profile-usertitle',
                            maximizeState: '.apex-ep-maximizestate',
                            closeSelector: '.apex-ep-closemodel',
                            handlerImageSelector: '.Apex-agentImage',
                            minimizedImage: '.apex-img-minimized-invite',
                            companyTitle: '.apex-company-title',
                            clicktoStart: '.apex-start-chat',
                            clickSourceId: '.apex-powerdby-minimized',
                            popoutSelector: '.apex-ep-openpopup',
                            regionEditorContainer: '#apexchat_exitpopup_region_container',
                            regionEditorContainerWrapper: `#${tpl.model.exitPopupRegionEditorContainerId}`
                        });
                        // me.uicontroller = new ApexChat.EPUIController({ model: tpl.model, chatModel: me.preLoadedOptions, elements: vwMin.elements, context: me.DOM });
                        // do event binding
                        if (me.options.chatMode == ChatMode.Windowed) {
                            me.$(vwMin.elements.popoutSelector, me.DOM).click(() => {
                                me.options.chatInitiatedBy = 'ExitPopup';
                                me.state.changeState({
                                    origin: WidgetTypes.ExitPopup,
                                    toState: WidgetStates.Hidden
                                });
                                me.startWindowedChat(me.options);
                            });
                        }
                        me.$(vwMin.elements.maximizeState, me.DOM).click(() => {
                            me.state.changeState({
                                origin: WidgetTypes.ExitPopup,
                                toState: WidgetStates.ShownMaximized
                            });
                            me.minOrMax(WidgetStates.ShownMaximized);
                        });
                        me.handleADA(me.$(vwMin.elements.closeSelector, me.DOM), () => {
                            me.uicontroller.end();
                        });
                        me.handleADA(me.$(vwMin.elements.maximizeState, me.DOM)[0], () => {
                            me.minOrMax(WidgetStates.ShownMaximized);
                        });
                        me.$(vwMin.elements.clickSourceId, me.DOM).html(tpl.model.poweredBy);
                        me.$(vwMin.elements.clicktoStart, me.DOM).html(
                            tpl.model.invitationMinimizedText
                        );
                        me.$(vwMin.elements.companyTitle, me.DOM).html(
                            tpl.model.exitPopupChat.chatTitle
                        );
                        // handlerImageUrl should be coming from what was assigned in widgetbase.js
                        me.$(vwMin.elements.handlerImageSelector, me.DOM).attr(
                            'src',
                            AgentImageHandler(tpl.model.handlerImageUrl)
                        );
                        me.$(vwMin.elements.agentTitle, me.DOM).html(tpl.model.agentName);
                        me.$(vwMin.elements.minimizedImage, me.DOM).attr(
                            'src',
                            tpl.model.handlerImageUrl
                        );
                        // finally, apply extra logic when shown
                        if (me.uicontroller) me.uicontroller.show(tpl.key); // _max or _min
                        // ADA Compliance
                        // summary: CSS Class 'apexchat_ada_compliance' has no CSS Styling behind it means it won't effect on UI.
                        // Its only for detecting the ADA Complianced HTML elements on which we do need to have the TAB Focus.
                        // This is the Utility function which takes all HTML elements having the class 'apexchat_ada_compliance' as ARRAY, and apply the TabIndex on all of them.
                        ApexChat.ADACompliant.push(
                            me.$('.apexchat_ada_compliance', me.DOM)
                        ).apply();
                        me.resize(tpl.key);
                    }
                }
            ],
            style: [
                // skinTemplate,
                me.options.invitationWidgetStyle,
                me.options.apexChatFontAwesomeCss
            ]
            // initialState: WidgetStates.ShownMaximized
        });
    }

    updateOptions(options) {
        options.handlerImageUrl = AgentImageHandler(options.handlerImageUrl);
        options.chatTitle = parseTemplate(
            options.exitPopupChat.chatTitleTemplate,
            options
        );
        if (options.headerDisclaimer) {
            options.headerDisclaimer = parseTemplate(
                options.headerDisclaimer,
                options
            );
        }
        return options
    }

    uiTweaks() {
        const me = this;
        me.$('.apex-msg-type', me.DOM).css('position', 'relative');
        me.$('.apex-popup-container', me.DOM).removeClass('HideClass');
        me.$('#apexchat-ep-minimize', me.DOM).removeClass('HideClass');
        me.$('.apex-popup-container', me.DOM).removeClass('apex-container-fix');
        // handle popup icon
        me.handlePopupIcon({
            chatMode: me.options.chatMode,
            popoutSelector: me.view.elements.popoutSelector,
            DOM: me.DOM
        });
        // me.$('.apex-input', me.DOM).css({ 'position': 'absolute', 'left': '0', 'float': '' });
        me.$('.apex-btn', me.DOM).css({ position: 'absolute', right: '0', float: '' });
    }

    handlePopupIcon(options) {
        const me = this;
        if (options.chatMode == ChatMode.DOM) {
            me.$(options.popoutSelector, options.DOM).hide();
        } else {
            me.$(options.popoutSelector, options.DOM).show();
        }
    }

    resize(state) {
        const me = this;
        setTimeout(() => {
            me.resizeIframe(state);
        }, 0);
    }

    resizeIframe(state) {
        const me = this;
        if (!me.resizeIFrameEP) {
            me.resizeIFrameEP = true;
        } else {
            return false;
        }
        setTimeout(() => {
            me.resizeIFrameEP = false;
        }, 500);
        me.uiTweaks();
        const widgetWrapper = document.getElementById(me.options.parentDivId);
        if (widgetWrapper) {
            const dragger = widgetWrapper.querySelector('#apexchat_ep_dragndrop');
            if (dragger && dragger.style) {
                dragger.style.display = 'block';
            }
        }
        if (state == WidgetStates.ShownMaximized) {
            let width = '651px';
            let height = getStyle(me.DOM.querySelector('.apex-transcript'), 'height');
            // TODO: we have to move this into Positioner
            const widgetIframe = document.getElementById(me.options.iframeId);
            widgetIframe.style.display = 'block';
            widgetWrapper.style.zIndex = '9999999';
            centerElement(widgetWrapper, {
                width: ApexChat.TempSize.iframeWidth,
                height: ApexChat.TempSize.iframeHeight
            });
            // For RD EP, we have different resizing.
            const headerLogo = getStyle(
                me.DOM.querySelector('.apex_rd_apex_title_logo'),
                'display'
            );
            // 5480 - hiding draggable area if headerLogo is not displaying.
            if (
                headerLogo === 'none' &&
                widgetWrapper.childNodes[1] && // Safety checks
                widgetWrapper.childNodes[1].getAttribute('id') === 'apexchat_ep_dragndrop'
            ) {
                hideElement(widgetWrapper.childNodes[1]);
            }
            if (height === 'auto') {
                height = '390px';
            }
            height = `${parseInt(height) + 40}px`;
        } else if (state == WidgetStates.ShownMinimized) {
            widgetWrapper.style.marginLeft = '0px'; // CHAT-5403 - Minimize state was not appearing due to 5359 change above.
            // me.$('#apexchat-ep-minimize', me.DOM).show();
            // me.$('#' + WidgetTypes.ExitPopup + WidgetStates.ShownMinimized, me.DOM).show();
            var width = '385px';
            var height = '185px';
            const display = 'block';
            me.postMessage({
                event: `${WidgetTypes.ExitPopup}_resize_iframe`,
                data: { state, height, width, display }
            });
        }
    }

    hide() {
        super.hide();
        const me = this;
        if (me.uicontroller) {
            me.uicontroller.hide();
        }
    }

    maximize() {
        super.maximize();
        const me = this;
        me.minOrMax(WidgetStates.ShownMaximized);
        // inform all interested of EP _max state
    }

    minOrMax(state) {
        const me = this;
        const stateToHide =
            state == WidgetStates.ShownMaximized
                ? WidgetStates.ShownMinimized
                : WidgetStates.ShownMaximized;
        // chat started but user maximizing from Min state? just show Max state
        if (me.chatStarted && me.chatStartOptions && me.chatStartOptions.chatId) {
            // TODO: improve this condition and convert to a function
            me.view.render(state); // will just show already present and hidden state of the widget
        } else {
            // On very 1st EP appear or page reload: 1. preload chat options, 2. render UI, 3. do after render stuff like event-binding and start pre-defined msgs
            if (!ApexChat.preLoadedOptions) {
                me.createView();
                me.preloadChatOptions(() => {
                    me.view.render(state);
                    // me.resize(state);//adjust size/position
                });
                return; // as this is v 1st display of EP on mouse exit
            }
            // on subsequent EP appear on User Max button click; just show Max state cuz both chat options and UI is already on page
            me.createView();
            me.view.render(state);
            me.view.unrender();
        }
        me.resize(state); // adjust size
        me.view.unrender(stateToHide); // hide another state if visible
    }

    minimize() {
        const me = this;
        me.minOrMax(WidgetStates.ShownMinimized);
        // inform all interested of EP _min state
        // me._super();
    }

    close() {
        const me = this;
        // this.resizeIframe(WidgetStates.ShownMaximized);
        me.state.changeState({
            origin: WidgetTypes.ExitPopup,
            toState: WidgetStates.Hidden
        });
    }

    // createRegionEditor() {
    //     const me = this;
    //     let regionEditorContainerWrapper = me.$(`#${me.options.exitPopupRegionEditorContainerId}`, me.DOM);
    //     if (regionEditorContainerWrapper && regionEditorContainerWrapper.length > 0) {
    //         return;
    //     }
    //     // Create region editor image
    //     me.createImage(me.options.exitPopupRegionEditorContainerId, InviteSize.ExitPopup);
    //     const regionEditorContainer = me.$('#apexchat_exitpopup_region_container', me.DOM);
    //     regionEditorContainerWrapper = me.$(`#${me.options.exitPopupRegionEditorContainerId}`, me.DOM);
    //     // Set Exit Popup region Editor html inside designated region
    //     regionEditorContainer.html(regionEditorContainerWrapper.html());
    // }
}
